import useVuelidate from '@vuelidate/core';
import { TypeCampaignEnum } from '@/types';
import { requiredWithMessage, includesValuesValidator } from '@/helpers/CustomValidator';
import type { FlowOperatorMetadata, ValidationResult, PickerData } from '@/types/flow-types';
import { canDeleteTrigger } from '@/components/flows/operators/registry';
import Form from './Form.vue';

export interface VisitPageData {
  custom_title: string;
  custom_description: string;
  trigger_location: number;
}

export interface ProductData {
  litteral_title?: {
    all?: string;
    product_picker_product?: string;
  };
  all?: number; // 0 = Une selection de produits. 1 = N'importe quel produit
  product_picker_product?: {
    selection: PickerData;
  };
}

export interface CategoryData {
  litteral_title?: {
    all?: string;
    product_picker_category?: string;
  };
  all?: number; // 0 = Une selection de categories. 1 = N'importe quel categorie
  product_picker_category?: {
    selection: PickerData;
  };
}

export interface ManufacturerData {
  litteral_title?: {
    all?: string;
    product_picker_manufacturer?: string;
  };
  all?: number;
  product_picker_manufacturer?: {
    selection: PickerData;
  };
}

export interface Url {
  url: string;
}
export interface UrlData {
  included?: Url[];
  excluded?: Url[];
}
export interface VisitPageFilters {
  products: ProductData;
  categories: CategoryData;
  manufacturers: ManufacturerData;
  urls: UrlData;
}

export function createDefaultData(data: Partial<VisitPageData> = {}): VisitPageData {
  return {
    custom_title: data.custom_title ?? '',
    custom_description: data.custom_description ?? '',
    trigger_location: data.trigger_location ?? 1,
  };
}

const VisitPage: FlowOperatorMetadata<VisitPageData> = {
  id: 'boxvisitpage',
  kind: 'trigger',
  label: 'flows.operators.visitPage.label',
  icon: 'fa-eye',
  hasConfiguration: true,
  availableIn: [],
  hidden: true,

  incompatibilities: {
    [TypeCampaignEnum.AUTOMATION]: {
      nextOperators: [
        'boxabandonpanier', 'boxperiodiclaunching', 'boxstatuscommand',
        'boxregisteronsite', 'boxsubscribetonewsletter', 'boxsendemail',
        'boxsendsms', 'boxsendfbmessenger', 'boxsendpushnotification',
        'openemail', 'clicklink', 'boxtriggerinternalevent', 'boxsendrcs', 'boxsendwhatsapp',
      ],
    },
  },

  Form,

  defaultData: createDefaultData,

  outputs: () => 1,

  async validate(data: VisitPageData): Promise<ValidationResult> {
    const rules = {
      custom_title: {
        requiredWithMessage: requiredWithMessage(),
      },
      trigger_location: {
        requiredWithMessage: requiredWithMessage(),
        includesValuesValidator: includesValuesValidator([0, 1]),
      },
    };

    const v$ = useVuelidate(rules, data);
    const success = await v$.value.$validate();
    return {
      success,
      validate: v$,
    };
  },

  canBeDeleted(operatorId: string, flow: any): Promise<boolean | string> {
    return canDeleteTrigger(flow, operatorId);
  },
};

export default VisitPage;
